Drupal.behaviors.sw_header_banner = {
  attach: function( context, settings ) {

    $('.header__banner').once('sw_header_banner').each(function() {
      let $w = $(this);
      $w.find('.header__banner__close').on('click', function( e ) {
        $w.slideUp(400, function() {
          $w.remove();
          $(window).resize();
        });
        $('.header-pad').animate({
          height: $('.header__top').height(),
        }, {
          duration: 400,
        });
        Cookies.set('sw_header_banner', $w.data('banner-id'), { expires: 30 });
      });
    });

  }
};
